/* Botón "Añadir" de las sugerencias del carrito lateral */
(function () {
  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.cart-upsell__add');
    if (!btn) return;
    evt.preventDefault();

    var select = btn.closest('.cart-upsell__item').querySelector('.cart-upsell__variant');
    var id = select ? select.value : btn.getAttribute('data-upsell-variant');
    var form = btn.closest('cart-form');
    btn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function () {
        if (form && typeof form.refresh === 'function') form.refresh();
        else window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
